module.exports = __webpack_public_path__ + "img/Site_plan_9.e1e4b2f5.gif";